import React from "react";
import { object, number } from "prop-types";
import { Link } from "@quintype/components";

import "./podcast-body.m.css";

const podcastLinks = [
  {
    title: "ಆ್ಯಪಲ್ ಪಾಡ್‌ಕಾಸ್ಟ್ ",
    url: "https://podcasts.apple.com/us/podcast/prajavani/id1513809381?uo=4"
  },
  {
    title: "ಸ್ಪಾಟಿಫೈ",
    url: "https://open.spotify.com/show/1sP238hOvftgLOq4NE6dEF"
  },
  {
    title: "ಗೂಗಲ್ ಪಾಡ್‌ಕಾಸ್ಟ್",
    url: "https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8yMDE0ODcwOC9wb2RjYXN0L3Jzcw=="
  },
  {
    title: "ಪಾಕೆಟ್ ಕಾಸ್ಟ್",
    url: "https://pca.st/nbsmgzz0"
  },
  {
    title: "ಓವರ್‌ಕಾಸ್ಟ್ ",
    url: "https://overcast.fm/itunes1513809381/prajavani"
  }
];

const PodcastBody = ({}) => {
  const podcastSpotifyLink = "https://anchor.fm/prajavani/";
  const podcastLink = "https://www.prajavani.net/podcast";

  const linkTag = (title, url) => (
    <Link styleName="link" href={url} target="_blank" rel="noopener noreferrer" key={url}>
      {title}
    </Link>
  );

  return (
    <div styleName="wrapper">
      <div styleName="line1">
        ಪ್ರಜಾವಾಣಿ ಕನ್ನಡ ಧ್ವನಿ ಪಾಡ್‌ಕಾಸ್ಟ್ ಆ್ಯಂಕರ್ ಚಾನೆಲ್‌ನಲ್ಲಿ ಕೇಳಲು
        {linkTag(" ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.", podcastSpotifyLink)}
      </div>
      <div styleName="line2">
        {podcastLinks.map((item) => linkTag(item.title, item.url))}ಈ ತಾಣಗಳಲ್ಲಿ ಕೂಡ ಪ್ರಜಾವಾಣಿಯ ಕನ್ನಡ ಧ್ವನಿ ಕೇಳಬಹುದು.
        ಸಂಬಂಧಿತ ಆ್ಯಪ್‌ಗಳು ಗೂಗಲ್ ಪ್ಲೇ ಸ್ಟೋರ್‌ನಲ್ಲಿ ದೊರೆಯುತ್ತವೆ.
      </div>
      <div styleName="line1">
        ಪ್ರಜಾವಾಣಿ ಪಾಡ್‌ಕಾಸ್ಟ್ ಸಂಗ್ರಹ ಇಲ್ಲಿದೆ–
        {linkTag(" ಕನ್ನಡ ಧ್ವನಿ", podcastLink)}
      </div>
    </div>
  );
};

PodcastBody.propTypes = {
  story: object,
  index: number
};

PodcastBody.propTypes = {
  story: object,
  index: number
};

export default PodcastBody;
